import { createContext } from "react";
import { Role } from "../types/types";

export const RoleContext = createContext<Role>("employee");
